<template>
    <v-card-title v-if="config.steps" class="pa-1" id="stepper-radial" data-qa="radialstepper-card-title-ecqvx8">
      <v-layout class="pb-2" data-qa="radialstepper-layout-27z5tb">
     <v-flex xs2 sm2 md1 lg3 xl3 class="pl-4 mt-2 mb-n1" data-qa="radialstepper-flex-umv1tq">
        <radial-progress-bar
          :diameter="70"
          :completed-steps="config.state"
          :total-steps="config.steps.length"
          :animateSpeed="900"
          :startColor="successColor"
          :stopColor="successColor"
          innerStrokeColor="#D3D3D3"
          :strokeWidth="6"
        >
          <font class="subtitle-1 font-weight-bold px-1">{{config.state}} of {{config.steps.length}}</font>
        </radial-progress-bar>
      </v-flex>
      <v-flex class="pl-8 pr-1 mt-1" xs10 sm10 md10 lg9 xl9 data-qa="radialstepper-flex-rxp0jd">
          <div
            v-for="(step, index) in config.steps"
            :key="index"
            :data-qa="`radialstepper-div-yq9hql-${index}`">
            <font
              v-if="isNextStepperState(index, config.state)"
              :color="primaryColor"
              :class="['title', 'font-weight-bold', config.displayWhiteText ? 'white--text': false ]"
            >  {{ `${$t(`termDepositActions.steps.${step.name}`)}` }}</font>
            <font
              v-if="isCurrentState(index, config.state)"
              :color="primaryColor"
              :class="['subtitle-1', 'ma-0', 'text-xs-right', config.displayWhiteText ? 'white--text': false ]"
            >Next: {{ `${$t(`termDepositActions.steps.${step.name}`)}` }}</font>
        </div>
      </v-flex>
      </v-layout>
    </v-card-title>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress'
import '@/styles/components/radialStepper.scss'

export default {
  name: 'step-radial-head',
  components: {
    RadialProgressBar
  },
  props: {
    config: {
      type: Object,
      default () {
        const steps = []
        const state = 0
        return {
          steps,
          state
        }
      }
    }
  },
  methods: {
    isNextStepperState: (index, stepperState) => stepperState === index + 1,
    isCurrentState: (index, stepperState) => index === stepperState
  }
}
</script>
